import { useMemo } from 'react';
import { useUser } from 'hooks';

export default function useUserFunctions() {
  const { user } = useUser();
  const isVIP = useMemo(() => user?.info?.userType === 'VIP_INVESTOR', [user]);
  return {
    isVIP,
  };
}
